import { render, staticRenderFns } from "./StepUpdates.vue?vue&type=template&id=1bd016d0&scoped=true&"
import script from "./StepUpdates.vue?vue&type=script&lang=ts&"
export * from "./StepUpdates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd016d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd016d0')) {
      api.createRecord('1bd016d0', component.options)
    } else {
      api.reload('1bd016d0', component.options)
    }
    module.hot.accept("./StepUpdates.vue?vue&type=template&id=1bd016d0&scoped=true&", function () {
      api.rerender('1bd016d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepUpdates.vue"
export default component.exports